// This reducer modify the state of individual counters
import Immutable from 'seamless-immutable'
import _ from 'lodash'

import * as actions from './actions'

const initialState = Immutable.from({
  requestedAd: {
    isFetching: false,
    error: false,
    errorId: null,
    ad: null,
  },
})

const classified = (state = initialState, { type, payload, error }) => {
  // Avoid using a default clause and let it go through
  let newState

  switch (type) {
    case actions.REQUEST_AD:
      return state.setIn(['requestedAd', 'isFetching'], true)
    case actions.RECEIVE_AD:
      if (error) {
        newState = {
          isFetching: false,
          ad: null,
          error: true,
          errorId: _.get(payload, 'content.error', null),
        }
      } else {
        newState = {
          isFetching: false,
          ad: payload,
        }
      }
      return state.set('requestedAd', newState).set('currentImageIndex', 0)
    default:
      return state
  }
}

export default classified
